import { GeometryTypeEnum } from '../enums/geometry-type-enum';
import { LayerTypeEnum } from '../enums/layer-type-enum';
import { BasemapProviderEnum } from '../enums/basemap-provider-enum';

export class LayerEntity {
  name!: string
  type!: LayerTypeEnum
  provider?: BasemapProviderEnum
  visible: boolean = false
  geometryType?: GeometryTypeEnum
  referenceSource?: string
  hasProxy?: boolean
  opacity: number = 1
  url?: string | null
  definitionQuery?: string | null
  definitionQueryWithLabel?: boolean
  definitionGeometry?: any
  filterWithGeometry?: boolean
  categoryField?: string | null
  fieldQuery?: string | null
  disabled?: boolean
  minScale?: number
  maxScale?: number
  layers?: LayerEntity[]
  abbreviation?: string
  queryFields?: string[]
  metadata?: any
  displayField?: string
  popupEnabled: boolean = true
  showLabels: boolean = true
  proxyUrl?: string | null
  instance?: any
  private _templateQuery?: string | null

  constructor(init?: Partial<LayerEntity>) {
    Object.assign(this, init);
  }

  setValue(value: any): void {
    if (this.filterWithGeometry) {
      this.definitionGeometry = value ?? null;
      return;
    }
    if (value === null || value === undefined || value === '') {
      this.definitionQuery = null;
      return;
    }
    if (this._templateQuery === undefined) {
      this._templateQuery = this.definitionQuery;
    }
    const template = this._templateQuery;
    if (template === null || template === undefined) {
      this.definitionQuery = null;
      return;
    }
    const normalized = typeof value === 'string'
      ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()
      : value;
    this.definitionQuery = template.replace('{0}', normalized);
  }
}


